import { cn } from "@lib/cn";
import {
  SlidesLibrarySidebarSkeleton,
  useSlidesLibraryStoreShallow,
} from "@modules/slides-library/shared";
import { ScrollArea } from "@/components/ui/scroll-area";
import type { TMasterSlide } from "@/shared/types";
import { useGetAiSlides, useScrollSidebar, useScrollToCategory } from "../hooks";

export const SidebarCategories = () => {
  const { data, isLoading } = useGetAiSlides();
  const { type, isInSearch } = useSlidesLibraryStoreShallow((s) => ({
    type: s.type,
    isInSearch: !!s.search,
  }));
  const onClick = useScrollToCategory();

  if (isLoading) return <SlidesLibrarySidebarSkeleton />;

  return (
    <ScrollArea className="tw-h-[calc(100vh-181px)] tw-max-h-[639px]">
      <div className="tw-space-y-2 tw-px-3 tw-py-3">
        {type === "templates" && (
          <>
            <CategoryItem
              title="Most Popular"
              _id="most-popular"
              onClick={onClick}
              isInSearch={isInSearch}
            />
            <CategoryItem
              title="Charts and Data"
              _id="charts-and-data"
              onClick={onClick}
              isInSearch={isInSearch}
            />
          </>
        )}
        {data?.categories?.map((item: TMasterSlide) => (
          <CategoryItem
            key={item._id}
            {...item}
            onClick={onClick}
            isInSearch={isInSearch}
          />
        ))}
      </div>
    </ScrollArea>
  );
};

export const CategoryItem = ({
  title,
  _id,
  onClick,
  isInSearch,
  className,
}: {
  title: string;
  _id: string;
  onClick: (id: string) => void;
  isInSearch: boolean;
  className?: string;
}) => {
  const activeCategoryId = useSlidesLibraryStoreShallow(
    (s) => s.activeTemplateCategoryId,
  );
  const isActive = activeCategoryId === _id;
  useScrollSidebar({ id: `category:${_id}`, isActive });
  return (
    <div
      onClick={() => onClick(_id)}
      data-sidebar-id={`category:${_id}`}
      className={cn(
        "tw-flex tw-h-8 tw-cursor-pointer tw-items-center tw-rounded-md tw-px-6 tw-font-sans tw-text-sm tw-font-normal tw-capitalize tw-text-blue tw-transition-colors hover:tw-bg-blue-100",
        isActive && !isInSearch && "tw-bg-blue-100",
        className,
      )}
    >
      {title}
    </div>
  );
};
